import React from "react";
import {
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import {
  KeyboardArrowRight as KeyboardArrowRightIcon,
  Add as AddIcon,
  Remove as RemoveIcon,
  SubdirectoryArrowRight as SubdirectoryArrowRightIcon,
} from "@mui/icons-material";

export interface SubCategoryItemData {
  id: string;
  name: string;
  icon?: "arrow" | "plus" | null;
  parent?: string;
  [key: string]: any;
}

interface SubCategoryItemProps {
  category: SubCategoryItemData;
  isSelected?: boolean;
  isExpanded?: boolean;
  isVisible?: boolean;
  selectedMainCategory?: string;
  onClick: () => void;
  onToggle?: () => void;
  paddingLeft?: number;
  isRootCategory?: boolean;
  sx?: any;
  itemSx?: any;
}

const SubCategoryItem: React.FC<SubCategoryItemProps> = ({
  category,
  isSelected = false,
  isExpanded = false,
  isVisible = true,
  selectedMainCategory,
  onClick,
  onToggle,
  paddingLeft,
  isRootCategory,
  sx,
  itemSx,
}) => {
  const handleClick = () => {
    if (category.icon === "arrow" && onToggle) {
      onToggle();
      // Sık kullanılanlarda da parent'ı selected yap
      if (selectedMainCategory === "sık-kullanılanlar") {
        onClick();
      }
    } else {
      onClick();
    }
  };

  const getIcon = () => {
    if (category.icon === "arrow") {
      // If frequent or history view is selected, show arrow instead of expandable icon
      if (selectedMainCategory === "sık-kullanılanlar" || selectedMainCategory === "geçmiş") {
        return <KeyboardArrowRightIcon />;
      }
      return isExpanded ? <RemoveIcon /> : <AddIcon />;
    }
    // If root category, show arrow
    if (isRootCategory) {
      return <KeyboardArrowRightIcon />;
    }
    // Otherwise show subdirectory arrow for child categories
    return <SubdirectoryArrowRightIcon sx={{ fontSize: 20 }} />;
  };

  const getPaddingLeft = () => {
    if (paddingLeft !== undefined) return paddingLeft;
    if (isRootCategory) return 0;
    if (category.depth !== undefined) return category.depth * 3;
    return 0;
  };

  const isActuallySelected = 
    isSelected || 
    (isExpanded && selectedMainCategory === "tümü" && isRootCategory);

  return (
    <ListItem
      sx={{
        p: 0,
        mb: 0.5,
        pl: getPaddingLeft(),
        display: isVisible ? "block" : "none",
        ...itemSx,
      }}
    >
      <ListItemButton
        onClick={handleClick}
        sx={{
          borderRadius: 1,
          backgroundColor: "transparent",
          color: isActuallySelected ? "primary.main" : "inherit",
          fontWeight: isActuallySelected ? "bold" : "normal",
          pl: 1,
          pr: 1,
          "&:hover": {
            backgroundColor: "action.hover",
          },
          ...sx,
        }}
      >
        <ListItemIcon sx={{ color: "inherit", minWidth: 36 }}>
          {getIcon()}
        </ListItemIcon>
        <ListItemText primary={category.name} />
      </ListItemButton>
    </ListItem>
  );
};

export default SubCategoryItem;

